import React, { useState, userEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/auth";
import "./LogoutConfirmationModal.css";

const LogoutConfirmationModal = ({ visible, onClose, onConfirm }) => {
  const { user, setAuthToken, setUser, logout } = useAuth();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (!visible) return null;

  const handleConfirm = async () => {
    setLoading(true);

    try {
      await logout({
        email: user?.email || "",
        setAuthToken,
        setUser,
        onSuccess: () => {
          navigate("/");
        },
        // onError: (message) => {
        //   console.error("Logout error:", message);
        // },
      });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <button className="close-button" onClick={onClose}>
            ✕
          </button>
        </div>

        <div
          className="logout-modal-content"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="logout-modal-image">
            <img src="/images/okayIcon.png" alt="Logout" />
          </div>

          <h2 className="modal-title">Logout</h2>
          <p className="modal-description">
            Are you sure you want to logout of NimbleBash?
          </p>

          <div className="modal-actions">
            <button className="cancel-button" onClick={onClose}>
              Back
            </button>
            <button
              className="confirm-button"
              onClick={handleConfirm}
              disabled={loading}
            >
              Yes, Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmationModal;
